export default __webpack_public_path__ + "40924507382de17104ed7147cb07d83c.png";